import { AxiosStatic, AxiosResponse } from 'axios';
import { TestEmail } from './TestEmail';
import VersionedResource from '../VersionedResource';

export default class SendEocEmailResource extends VersionedResource {
  public async sendEocEmail(fiId: string, cycleId: number) : Promise<void> {
    const url = `/api/rcx/config/${fiId}/eoc-email-settings/send-eoc-email/${cycleId}`;
    const response: AxiosResponse = await this.apiClient.post(url);
  }

  public async testEocEmail(fiId: string, cycleId: number, testEmail: TestEmail) : Promise<void> {
    const url = `/api/rcx/config/${fiId}/eoc-email-settings/test-eoc-email/${cycleId}`;
    const response: AxiosResponse = await this.apiClient.post(url, testEmail);
  }
}
